
//会员权益相关接口
import { get, put, putJson, postJson } from '@/api/jhk/axios.js'


/**
 * 获取会员等级权益
 */
export const getMemberBenefitInfo = p => postJson(`/memberBenefit/getMemberBenefitInfo`, p)

/**
 * 创建会员权益
 */
export const createMemberBenefitInfo = p => postJson(`/memberBenefit/createMemberBenefitInfo`, p)

/**
 * 删除会员权益
 */
export const deleteMemberBenefitInfo = id => postJson(`/memberBenefit/delete/deleteMemberBenefitInfo?id=${id}`)
